const calendarDay = (date, timeZone) => {
  if (!timeZone) {
    return Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
  }
  const [year, month, day] = new Intl.DateTimeFormat('en-CA', { timeZone })
    .format(date)
    .split('-')
    .map(Number);
  return Date.UTC(year, month - 1, day);
};

/**
 * Formata a data de renovação de um desafio para exibição
 * @param {string} nextAvailableAt - Data ISO string de quando o desafio estará disponível novamente
 * @param {string} [timeZone] - Fuso usado para comparar os dias; sem ele, compara em UTC
 * @returns {string} String formatada: "Amanhã", "em 2 dias", "em 7 dias", etc.
 */
export const formatNextAvailableDate = (nextAvailableAt, timeZone) => {
  if (!nextAvailableAt) return '';

  try {
    const nextDate = new Date(nextAvailableAt);
    const now = new Date();

    const dayMs = 1000 * 60 * 60 * 24;
    const nextUtcMidnight = calendarDay(nextDate, timeZone);
    const todayUtcMidnight = calendarDay(now, timeZone);

    const diffInMs = nextUtcMidnight - todayUtcMidnight;
    const diffInDays = Math.round(diffInMs / dayMs);

    // console.debug('formatNextAvailableDate UTC:', { nextUtcMidnight: new Date(nextUtcMidnight), todayUtcMidnight: new Date(todayUtcMidnight), diffInDays });

    // Se for amanhã
    if (diffInDays === 1) {
      return 'Amanhã';
    }

    // Se for em N dias (futuro)
    if (diffInDays > 1) {
      return `em ${diffInDays} dias`;
    }

    // Se já passou ou é hoje, retorna vazio
    return '';
  } catch (error) {
    console.error('Erro ao formatar data de renovação:', error);
    return '';
  }
};

